import type { DocNetInboxItem } from 'src/@types/docnet';
import DocNetBaseService from 'src/services/docnet/DocNetBaseService';
import { api } from 'src/pages/APIs';

export default class DocNetInboxService extends DocNetBaseService {
  public async getItems(filters?: {
    type?: string;
    status?: string;
  }): Promise<DocNetInboxItem[]> {
    const headers = await this.getHeaders();
    const params = new URLSearchParams();
    if (filters?.type) params.set('type', filters.type);
    if (filters?.status) params.set('status', filters.status);
    const qs = params.toString();
    const url = api.docnet_inbox + (qs ? `?${qs}` : '');
    const response = await super.get(url, { headers });
    const data = (response as any)?.items ?? response;
    if (!Array.isArray(data)) {
      console.warn('[DocNet] getItems: unexpected response shape, returning []', response);
      return [];
    }
    return data as DocNetInboxItem[];
  }

  public async getItem(id: string): Promise<DocNetInboxItem> {
    const headers = await this.getHeaders();
    return (await super.get(`${api.docnet_inbox}/${id}`, { headers })) as DocNetInboxItem;
  }

  public async actOnItem(
    id: string,
    action: 'approve' | 'reject' | 'reassign' | 'comment',
    payload?: any,
  ): Promise<DocNetInboxItem> {
    const headers = await this.getHeaders();
    return (await super.post(
      `${api.docnet_inbox}/${id}/actions`,
      { action, ...payload },
      { headers },
    )) as DocNetInboxItem;
  }

  public async actOnItems(
    ids: string[],
    action: 'approve' | 'reject' | 'dismiss',
    resolutionNotes?: string,
  ): Promise<DocNetInboxItem[]> {
    const headers = await this.getHeaders();
    return (await super.post(
      `${api.docnet_inbox}/bulk-actions`,
      { ids, action, resolution_notes: resolutionNotes },
      { headers },
    )) as DocNetInboxItem[];
  }

  public async dismissItem(id: string): Promise<void> {
    const headers = await this.getHeaders();
    await super.post(`${api.docnet_inbox}/${id}/dismiss`, {}, { headers });
  }
}
